function headerDropdown() {
    const block = document.querySelectorAll('[data-dropdown-block]');


    block.forEach(el => {
        const btn = el.querySelector('[data-dropdown-btn]');

        btn.addEventListener('click', _ => {
            el.classList.toggle('is-open');
        })
    })

    document.addEventListener('click', e => {
        if (e.target.closest('[data-dropdown-closable]')) return;
        document.querySelectorAll('[data-dropdown-closable].is-open').forEach(e => e.classList.remove('is-open'))
    })
}

export default headerDropdown;
